// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"131":"8a338eab","740":"4dcdcf4d"}[chunkId] + ".chunk.css";
};